module.exports = __webpack_public_path__ + "static/media/met-logo-hvit.efe2ecd1.svg";